import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import apiSlice from '../features/api/apiSlice';
import filterReducer from "../features/filter/filterSlice"

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    filter: filterReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});
